import React, { useCallback } from "react"
import * as AppConstants from "@/utility/AppConstants"
import "Css/table.css"
import { TableFieldsMultiAnno } from "@/utility/model"

function TabReddito(props: TableFieldsMultiAnno) {
    let elemNonDisponibile = AppConstants.ELEMENTO_NON_DISPONIBILE
    return (
        <React.Fragment>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {" "}
                    {AppConstants.DATI_REDDITO_DICHIARATI}{" "}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {props.campo1 !== undefined
                            ? props.campo1.reddDic
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.reddDic
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                <td>
                    {props.campo3 !== undefined
                        ? props.campo3.reddDic
                        : elemNonDisponibile}
                </td>
            </tr>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {AppConstants.DATI_REDDITO_STIMATI}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {props.campo1 !== undefined
                            ? props.campo1.reddSti
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.reddSti
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                <td>
                    {props.campo3 !== undefined
                        ? props.campo3.reddSti
                        : elemNonDisponibile}
                </td>
            </tr>

            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {AppConstants.DATI_REDDITO_ADDETTO_DICHIARATI}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {props.campo1 !== undefined
                            ? props.campo1.reddAddDic
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {" "}
                        {props.campo2 !== undefined
                            ? props.campo2.reddAddDic
                            : elemNonDisponibile}{" "}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                <td>
                    {" "}
                    {props.campo3 !== undefined
                        ? props.campo3.reddAddDic
                        : elemNonDisponibile}{" "}
                </td>
            </tr>
            <tr className="tableStatIsa">
                <th className="th_punteggio_isa">
                    {" "}
                    {AppConstants.DATI_REDDITO_ADDETTO_STIMATI}
                </th>
                {props.isCampo1 ? (
                    <td>
                        {props.campo1 !== undefined
                            ? props.campo1.reddAddSti
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                {props.isCampo2 ? (
                    <td>
                        {props.campo2 !== undefined
                            ? props.campo2.reddAddSti
                            : elemNonDisponibile}
                    </td>
                ) : (
                    <React.Fragment />
                )}
                <td>
                    {" "}
                    {props.campo3 !== undefined
                        ? props.campo3.reddAddSti
                        : elemNonDisponibile}{" "}
                </td>
            </tr>
        </React.Fragment>
    )
}
export default TabReddito
